import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getBank, Icon, SimpleModal, SelectMenu } from '@livable/saas-react-components';
import { Typography, MenuItem, Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useStore } from 'src/stores';
import useStyles from './styles';
const ChangePaymentMethodModalV2 = observer(_ref => {
  var _selectedSubscription;
  let selectedSubscriptionData = _ref.selectedSubscriptionData,
    triggerRefresh = _ref.triggerRefresh,
    customTrigger = _ref.customTrigger;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(store.payment.paymentMethods),
    _useState4 = _slicedToArray(_useState3, 2),
    paymentMethods = _useState4[0],
    setPaymentMethods = _useState4[1];
  const _useState5 = useState((_selectedSubscription = selectedSubscriptionData.paymentMethod) === null || _selectedSubscription === void 0 ? void 0 : _selectedSubscription.id),
    _useState6 = _slicedToArray(_useState5, 2),
    value = _useState6[0],
    setValue = _useState6[1];
  const handleSearch = v => {
    const currentArray = [];
    paymentMethods.map(i => {
      if (i.last4.toLocaleLowerCase().includes(v.trim().toLocaleLowerCase())) {
        currentArray.push(i);
      }
    });
    setPaymentMethods(currentArray);
  };
  const handleChange = data => setValue(data);
  const handleGenericModalClose = () => {
    var _selectedSubscription2;
    setValue((_selectedSubscription2 = selectedSubscriptionData.paymentMethod) === null || _selectedSubscription2 === void 0 ? void 0 : _selectedSubscription2.id);
  };
  const setPaymentMethod = async (data, closeCallback) => {
    setIsLoading(true);
    const setPropertyPayment = async (property, methodId) => store.payment.setPropertyPaymentMethodAsync.run({
      propertyId: property.propertyId,
      paymentMethodId: methodId
    });
    const respArr = [];
    for (const p of selectedSubscriptionData.assignedProperties || []) {
      const contents = await setPropertyPayment(p, data);
      respArr.push(contents);
    }
    setIsLoading(false);
    if (respArr.some(r => r.isSuccessful)) {
      closeCallback();
      if (triggerRefresh) {
        triggerRefresh();
      }
    }
  };
  const modalTitle = "".concat(t('subscriptions.change_payment_method'));
  const modalSubTitle = "".concat(selectedSubscriptionData.assignedProperties.map(p => p.propertyAddress).join(', '));
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '285-change-payment-method-modal-v2'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('buttons.change')));
  const ModalContent = _ref2 => {
    var _selectedSubscription3;
    let handleModalClose = _ref2.handleModalClose,
      handler = _ref2.handler;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.form
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.formContent
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, t('subscriptions.select_payment_method')), /*#__PURE__*/React.createElement("div", {
      className: classes.changePayment
    }, /*#__PURE__*/React.createElement(SelectMenu, {
      id: "payment-selector"
      // enableSearch={true}
      ,
      labelId: "payment-selector-label",
      label: "",
      disabled: store.payment.paymentMethods.length === 0,
      onSearch: handleSearch,
      searchPlaceholder: 'Search for payment method',
      onChange: e => handleChange(e.target.value),
      value: value,
      renderValue: selected => {
        if (selected.length === 0) {
          return '';
        }
        const found = paymentMethods.find(item => item.id === selected);
        return !!found ? "".concat(getBank(found.brand).title, " ****").concat(found.last4) : '';
      }
    }, paymentMethods.map(i => {
      var _getBank;
      return /*#__PURE__*/React.createElement(MenuItem, {
        value: i.id,
        key: i.id,
        className: classes.changePaymentItem
      }, /*#__PURE__*/React.createElement("span", null, (_getBank = getBank(i.brand)) === null || _getBank === void 0 ? void 0 : _getBank.title), /*#__PURE__*/React.createElement("i", null, " ****", i.last4));
    })))), /*#__PURE__*/React.createElement("div", {
      className: classes.footerWrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.rightButton
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      disabled: value === ((_selectedSubscription3 = selectedSubscriptionData.paymentMethod) === null || _selectedSubscription3 === void 0 ? void 0 : _selectedSubscription3.id) || isLoading,
      onClick: () => {
        handler(value, handleModalClose);
      },
      'custom-attribute': '286-change-payment-method-modal-v2'
    }, t('buttons.save_changes')))));
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: customTrigger !== undefined ? customTrigger : defaultTrigger || null,
    title: modalTitle,
    subTitle: modalSubTitle,
    handleClose: handleGenericModalClose,
    noFooter: true
  }, /*#__PURE__*/React.createElement(ModalContent, {
    handleModalClose: handleGenericModalClose,
    handler: setPaymentMethod
  }));
});
ChangePaymentMethodModalV2.propTypes = {
  trigger: PropTypes.node
};
export default ChangePaymentMethodModalV2;